import { IUserProfileController } from "../../../../../core";
import { UserProfileControllerImpl } from "../../../business";

export class UserProfileControllerFactory {
    static create(): IUserProfileController {
        return new UserProfileControllerImpl();
    }
}
